<template>
    <v-map :bounds="bounds" :zoom="13" :center="[47.413220, -1.219482]">
        <v-tilelayer url="https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga"/>

        <v-marker v-for="marker in markers" :icon="marker.icone" :key="marker.id" :lat-lng="marker.position" v-if="user">
            <v-popup :content="marker.tooltip"/>
            <v-tooltip :content="marker.tooltip"/>
        </v-marker>

        <div v-for="marker in repetidores" :key="marker.id">
            <v-lcircle :lat-lng="marker.position" :radius="marker.radius"/>
            <v-marker :key="marker.id" :icon="getIcon(marker.icone)" :lat-lng="marker.position">
                <v-popup :content="marker.tooltip"/>
                <v-tooltip :content="marker.tooltip"/>
            </v-marker>
        </div>
    </v-map>
</template>
<script>
/* global L */
import { Contratos, Pontos } from "../../class/index";
import _ from "lodash-es";

export default {
    data() {
        return {
            markers: [],
            bounds: L.latLngBounds(),
            icon_compass: L.icon({
                iconUrl: "image/compass.png",
                iconSize: [24, 24]
            }),
            icon_compass_amarelo: L.icon({
                iconUrl: "image/compass_amarelo.png",
                iconSize: [24, 24]
            }),
            icon_compass_preto: L.icon({
                iconUrl: "image/compass_preto.png",
                iconSize: [24, 24]
            }),
            icon_compass_roxo: L.icon({
                iconUrl: "image/compass_roxo.png",
                iconSize: [24, 24]
            }),
            icon_compass_verde: L.icon({
                iconUrl: "image/compass_verde.png",
                iconSize: [24, 24]
            }),
            icon_share: L.icon({
                iconUrl: "image/share.png",
                iconSize: [24, 24]
            }),
            icon_arrows: L.icon({
                iconUrl: "image/arrows.png",
                iconSize: [24, 24]
            }),
            icon_point_amarelo: L.icon({
                iconUrl: "image/point_amarelo.png",
                iconSize: [24, 24]
            }),
            icon_point_azul: L.icon({
                iconUrl: "image/point_azul.png",
                iconSize: [24, 24]
            }),
            icon_point_roxo: L.icon({
                iconUrl: "image/point_roxo.png",
                iconSize: [24, 24]
            }),
            icon_point_verde: L.icon({
                iconUrl: "image/point_verde.png",
                iconSize: [24, 24]
            }),
            icon_point_vermelho: L.icon({
                iconUrl: "image/point_vermelho.png",
                iconSize: [24, 24]
            }),
            repetidores: [],
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    mounted() {
        if (this.user) {
            Contratos.allPositions()
                .then(rows => this.fillMarker(rows))
                .then(() => this.fitPolyline())
                .catch(err => console.error(err));
        }

        Pontos.allPontos()
            .then(rows => this.fillRepetidor(rows))
            .then(() => this.fitPolyline())
            .catch(err => console.error(err));
    },
    methods: {
        getIcon(icon) {
            console.log(icon);
            switch (icon) {
                case "compass.png":
                    return this.icon_compass;
                case "compass_amarelo.png":
                    return this.icon_compass_amarelo;
                case "compass_preto.png":
                    return this.icon_compass_preto;
                case "compass_roxo.png":
                    return this.icon_compass_roxo;
                case "compass_verde.png":
                    return this.icon_compass_verde;
                case "share.png":
                    return this.icon_share;
                case "arrows.png":
                    return this.icon_arrows;
                case "point_amarelo.png":
                    return this.icon_point_amarelo;
                case "point_azul.png":
                    return this.icon_point_azul;
                case "point_roxo.png":
                    return this.icon_point_roxo;
                case "point_verde.png":
                    return this.icon_point_verde;
                case "point_vermelho.png":
                    return this.icon_point_vermelho;
            }
        },
        fitPolyline: function() {
            let ll = _.concat(this.markers, this.repetidores);
            this.bounds = L.latLngBounds(ll.map(o => o.position));
        },
        fillMarker(rows) {
            rows.forEach(row => {
                let icon =
                    row.tipo === "RADIO"
                        ? this.icon_point_verde
                        : this.icon_point_azul;
                if (row.geocode && row.geocode.latitude) {
                    this.markers.push({
                        id: row._id,
                        position: {
                            lat: row.geocode.latitude,
                            lng: row.geocode.longitude
                        },
                        tooltip: row.cliente.nome,
                        icone: icon
                    });
                }
            });
        },
        fillRepetidor(rows) {
            rows.forEach(row => {
                if (row.geocode && row.geocode.latitude) {
                    this.repetidores.push({
                        id: row._id,
                        position: {
                            lat: row.geocode.latitude,
                            lng: row.geocode.longitude
                        },
                        tooltip: row.nome,
                        icone: row.icon,
                        radius: row.radius
                    });
                }
            });
        }
    }
};
</script>
